import { useState } from 'react'
import {
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  InputGroup,
  InputRightElement,
  Text
} from '@chakra-ui/react'

import StyledInput from './input'

// An input with a permanent label on top, a plain-language hint below it and an
// inline error message, so the user never has to guess what a field is for.
const LabeledInput = ({
  label,
  hint,
  error,
  isOptional,
  isSecret,
  onEnter,
  ...inputProps
}) => {
  const [isRevealed, setRevealed] = useState(false)

  const { type = 'text', value = '', maxLength, ...rest } = inputProps

  return (
    <FormControl isInvalid={Boolean(error)} mb={2}>
      <Flex align="center" justify="space-between" mb={1}>
        <FormLabel
          fontSize={11}
          fontWeight={700}
          letterSpacing={2}
          color="black"
          m={0}
        >
          {label}
          {isOptional && (
            <Text as="span" fontWeight={400} letterSpacing={0} opacity={0.6}>
              {' '}
              (optional)
            </Text>
          )}
        </FormLabel>
        {maxLength && value.length > 0 && (
          <Text fontSize={11} opacity={0.5}>
            {value.length}/{maxLength}
          </Text>
        )}
      </Flex>
      <InputGroup>
        <StyledInput
          type={isSecret && !isRevealed ? 'password' : type}
          value={value}
          maxLength={maxLength}
          pr={isSecret ? '4.5rem' : undefined}
          boxShadow={
            error ? 'inset 0 0 0 1px var(--chakra-colors-main-red)' : undefined
          }
          onKeyDown={e => {
            if (e.key === 'Enter' && onEnter) onEnter()
          }}
          {...rest}
        />
        {isSecret && (
          <InputRightElement w="4.5rem" h="full">
            <Button
              variant="outline-mini-black"
              tabIndex={-1}
              onClick={() => setRevealed(!isRevealed)}
            >
              {isRevealed ? 'HIDE' : 'SHOW'}
            </Button>
          </InputRightElement>
        )}
      </InputGroup>
      {error ? (
        <FormErrorMessage fontSize={12} color="main-red" mt={1}>
          {error}
        </FormErrorMessage>
      ) : (
        <FormHelperText fontSize={12} color="black" opacity={0.6} mt={1}>
          {hint}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default LabeledInput
